import { Card, CardContent, styled } from '@material-ui/core';
import React, { forwardRef } from 'react';
import { DismissButton, FocusScope, mergeProps, useDialog, useModal, useOverlay } from 'react-aria';
import { palettePrimaryMain } from 'src/setup/css-vars';

export type DropdownProps = {
  title: (props: { titleProps: React.DOMAttributes<Element> }) => JSX.Element;
  children?: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  style?: React.CSSProperties;
  className?: string;
};

// static style object on purpose — see the note in cars-table-next/table/TableCell.tsx
const DropdownContainer = styled(Card)({
  '&:focus-visible': {
    outlineColor: palettePrimaryMain,
  },
});

const DropdownContent = styled(CardContent)({});

export const Dropdown = forwardRef<HTMLDivElement, DropdownProps>(
  ({ title, children, isOpen, onClose, style, ...otherProps }, ref) => {
    const { overlayProps } = useOverlay(
      {
        onClose,
        isOpen,
        isDismissable: true,
      },
      ref as any, // FIXME: inspect types
    );

    const { modalProps } = useModal();

    const { dialogProps, titleProps } = useDialog(
      {},
      ref as any, // FIXME: inspect types
    );

    return (
      <FocusScope contain restoreFocus>
        <DropdownContainer
          {...mergeProps(overlayProps, dialogProps, otherProps, modalProps)}
          ref={ref}
          raised
          style={{
            ...style,
          }}
        >
          <DropdownContent>
            {title({ titleProps })}
            {children}
          </DropdownContent>
          <DismissButton onDismiss={onClose} />
        </DropdownContainer>
      </FocusScope>
    );
  },
);
